<template>
  <div class="container presentation-container">
    <header style="background-color: #05689a;height: auto;width: 100%;padding: 25px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/orep-white-logo.png"  height="68" width="230" alt="Logo">
        </div>
      </div>
    </header>
    <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px;">

      <div class="row">
        <div class="col-md-8">
          <p class="comic-font-bold" style="font-size: 30px; color: #05689a">
            <img src="">
            <strong>SECURE PAYMENT PROCESSING</strong>
          </p>
        </div>
        <div class="col-md-auto text-center">
          <img src="../../../public/assets/images/call-1.png" alt="18 years">
        </div>
      </div>
      <hr class="new1" />

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <p class="comic-font-bold" style="font-size: 20px;">
                An OREP Membership Fee of $150 will be added to your Premium.
              </p>
            </div>
          </div>

          <hr class="new1">
        </div>

      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-auto text-left">
          <table class="">
            <tbody>

            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>Input Premium Due Here:</strong>
                </p>
              </td>
              <td>
                <input
                  name="premium"
                  type="number"
                  :placeholder="'$0'"
                  style="width: 500px;"
                  v-model="state.premium"
                  min="1"
                  @input="validateBeforeSubmit()"
                  v-validate="'required'"
                >
                <span
                  v-show="errors.has('premium')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('premium') | filterText }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong>OREP Member Fee:</strong>
              </td>
              <td>
                <input :placeholder="'$'+orepfee().toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-left">
              <p>
                <strong>
                  <i>Please Note:</i>
                </strong>
                Your Insurance Policy is not in effect/bound until Payment or Down-Payment is received. <strong style="text-decoration: underline">To expedite coverage and avoid delays, please use one of these two links to make payment now.</strong>
              </p>
            </div>
          </div>
        </div>

      </div>

      <hr class="new1" />

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          SELECT PAYMENT TYPE
        </p>
      </div>

      <div style="margin-top: 30px;margin-bottom: 50px;">
        <div>
          <div class="radio-button " style="text-align: center;align-content: center;justify-content: center">
            <div class="radio-button row" style="justify-content: center">
              <div>
                <input  type="radio" id="radio1" name="radios" :value=false v-model="state.paymentType" checked>
                <label for="radio1" style="margin-left: 40px;height: 275px;width: 250px" >
                  <i class="fa fa-bank fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Debit Card / ACH</strong>
                  </p>
                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="SSL image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Amount: ${{ this.state.total }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Fee: $0.00</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;">
                    <strong>Total: ${{ this.state.total }}</strong>
                  </p>
                  <p class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    No Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    for Debit Card or ACH
                  </p>
                </label>
              </div>

              <div>
                <input type="radio" id="radio2" name="radios" :value=true v-model="state.paymentType">
                <label for="radio2" style="margin-left: 40px;height: 275px;width: 250px">
                  <i class="fa fa-credit-card fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Credit Card</strong>
                  </p>


                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="background image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Amount: ${{ this.state.total }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Fee: ${{ this.state.processingFee }}</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;">
                    <strong>Total: ${{ this.state.grandTotal }} </strong>
                  </p>
                  <p class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    0.9% Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    Lowest in the Industry!
                  </p>
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr class="new1" />
      <div v-show="state.paymentType === true" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div>
<!--          <form action="https://www.asecurecart.net/server/cart.aspx/workingre2" target="_blank" method="POST" name="frm">-->
<!--            <input name="TaxItem" type="hidden" value="n">-->
<!--            <input type="hidden" Name="AddEmail" Value="underwriting@orep.org">-->
<!--            <input name="ID" type="hidden" value="Premium">-->
<!--            <input name="ID" type="hidden" value="OREP Member Fee">-->
<!--            <input name="ID" type="hidden" value="Processing Fee">-->
<!--            <input name="Price" type="hidden" :value="this.state.premium">-->
<!--            <input name="Price" type="hidden" :value="this.state.orepfee">-->
<!--            <input name="Price" type="hidden" :value="this.state.processingFee">-->
<!--            <input name="Multi" type="hidden" value="Y">-->
<!--            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                   name="Submit" type="submit" :disabled="!state.pageOneIsValid" :class="{submitDisabled: !state.pageOneIsValid}"  value="PROCEED TO PAYMENT">-->
<!--          </form>-->

          <form action="https://orep.foxycart.com/cart?category=CP-Accelerant" method="post" target="_blank">
            <input type="hidden" name="name" value="Premium">
            <input type="hidden" name="price" :value="this.state.premium">
            <input type="hidden" name="quantity_max" value="1">
            <input type="hidden" name="quantity_min" value="1">

            <input type="hidden" name="2:name" value="OREP Member Fee">
            <input type="hidden" name="2:price" :value="this.state.orepfee">
            <input type="hidden" name="2:quantity_max" value="1">
            <input type="hidden" name="2:quantity_min" value="1">

            <input type="hidden" name="3:name" value="Processing Fee">
            <input type="hidden" name="3:price" :value="this.state.processingFee">
            <input type="hidden" name="3:quantity_max" value="1">
            <input type="hidden" name="3:quantity_min" value="1">


            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                   name="Submit" type="submit" :disabled="!state.pageOneIsValid" :class="{submitDisabled: !state.pageOneIsValid}"  value="PROCEED TO PAYMENT">

          </form>

        </div>
        <a href="https://orep.org/google-reviews/" target="_blank">
          <img
            src="../../../public/assets/images/vcr_large.png"
            height="115"
            width="150"
            alt="SSL image"
          >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
      <div v-show="state.paymentType === false" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div >
<!--          <form action="https://www.asecurecart.net/server/cart.aspx/workingre2" target="_blank" method="POST" name="frm1">-->
<!--            <input name="TaxItem" type="hidden" value="n">-->
<!--            <input type="hidden" Name="AddEmail" Value="underwriting@orep.org">-->
<!--            <input name="ID" type="hidden" value="Premium">-->
<!--            <input name="ID" type="hidden" value="OREP Member Fee">-->
<!--            <input name="Price" type="hidden" :value="this.state.premium">-->
<!--            <input name="Price" type="hidden" :value="this.state.orepfee">-->
<!--            <input name="Multi" type="hidden" value="Y">-->
<!--            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                   name="Submit" type="submit" :disabled="!state.pageOneIsValid" :class="{submitDisabled: !state.pageOneIsValid}"  value="PROCEED TO PAYMENT">-->
<!--          </form>-->

          <form action="https://orep.foxycart.com/cart?category=CP-Accelerant" method="post" target="_blank">
            <input type="hidden" name="name" value="Premium">
            <input type="hidden" name="price" :value="this.state.premium">
            <input type="hidden" name="quantity_max" value="1">
            <input type="hidden" name="quantity_min" value="1">

            <input type="hidden" name="2:name" value="OREP Member Fee">
            <input type="hidden" name="2:price" :value="this.state.orepfee">
            <input type="hidden" name="2:quantity_max" value="1">
            <input type="hidden" name="2:quantity_min" value="1">

            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                   name="Submit" type="submit" :disabled="!state.pageOneIsValid" :class="{submitDisabled: !state.pageOneIsValid}"  value="PROCEED TO PAYMENT">

          </form>

        </div>
        <a href="https://orep.org/google-reviews/" target="_blank">
          <img
            src="../../../public/assets/images/vcr_large.png"
            height="115"
            width="150"
            alt="SSL image"
          >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
    </div>


    <footer style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/orep-white-logo.png" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC || CA License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            appraisers@OREP.org
          </p>
        </div>
      </div>

    </footer>
  </div>

</template>
<script>
import $ from "jquery";
import moment from "moment";
export default {

  name: "custom-payment",
  computed: {

    ipfs() {
      return this.$store.state.ipfs.ipfs;
    },
    state() {
      return this.$store.state.ipfs;
    },
    errorMsg() {
      return this.$store.state.ipfs.errorMsg;
    },
  },
  // created: function(){
  //   if (this.state.premium == 0){
  //     window.location.href = "https://orep.org/appraiser-portal-payment/"
  //     // this.$router.push('https://orep.org/appraiser-portal-payment/')
  //   }
  // },
  methods: {
    validateBeforeSubmit() {
      this.total();
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    orepfee() {
      // const params = this.$route.query;
      // if (params && params.orepfee) {
      //   this.state.orepfee = Number(params.orepfee);
      // }
      this.state.orepfee = 150;
      return this.state.orepfee;
    },
    premium() {
      // const params = this.$route.query;
      // if (params && params.premium) {
      //   this.state.premium = Number(params.premium);
      // }
      return this.state.premium;
    },
    financefee() {
      const params = this.$route.query;
      if (params && params.financefee) {
        this.state.financefee = Number(params.financefee);
      }
      return this.state.financefee;
    },
    total() {
      this.state.total = parseFloat(this.state.premium) + parseFloat(this.state.orepfee);
      this.state.processingFee = (this.state.total * 0.009).toFixed(2);
      this.state.grandTotal = parseFloat(this.state.total) +  parseFloat(this.state.processingFee);
    },
    processing_fee() {
      this.state.processingFee = (this.state.total * 0.009).toFixed(2);
    },
  },
  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  mounted() {
    const params = this.$route.query;
    if (params && params.orepfee) {
      this.state.orepfee = Number(params.orepfee);
    }
    if (params && params.financefee) {
      this.state.financefee = Number(params.financefee);
    }
    if (params && params.premium) {
      this.state.premium = Number(params.premium);
    }
    if (params && params.individual_name) {
      this.state.ipfs.individualName = params.individual_name;
    }
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top
    }, 500);

  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
.radio-button {
  margin: 15px;
}
.radio-button input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-button label {
  display: inline-block;
  background-color: #ffffff;
  padding: 10px 40px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border: 1px solid #05689a;
  border-radius: 4px;
}
.radio-button label:hover {
  background-color: #05689a;
}

.radio-button input[type="radio"]:focus + label {
  border: 2px dashed #f1f1f1;
}
.radio-button input[type="radio"]:checked + label {
  background-color: #f1f1f1;
  border-color: #05689a;
}

.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
li{
  margin: 12px 0;
}
table td {
  padding: 0 5px 15px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


::placeholder {
  color: black;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}
.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans';
}
.comic-font-bold{
  font-family: 'Open Sans';
  font-weight: bold;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}
</style>
